import { Card, PageHeader } from '@catering/ui';
import { Link } from '@tanstack/react-router';
import { BookOpen } from 'lucide-react';
import type { JSX } from 'react';

import { GLOSSARY_TERMS } from '../../guide/glossary';

/** `guide-search/spec.md`: destination for glossary search results. */
export function GlossaryPage(): JSX.Element {
  const sortedTerms = [...GLOSSARY_TERMS].sort((a, b) => a.term.localeCompare(b.term, 'es'));

  return (
    <section className="flex flex-col gap-6">
      <PageHeader
        icon={BookOpen}
        title="Glosario"
        description="Términos clave usados en la guía, con sus definiciones."
      />

      <div className="flex flex-col gap-3">
        {sortedTerms.map((entry) => (
          <Card key={entry.id} className="flex flex-col gap-1">
            <h2 className="text-sm font-semibold text-slate-900">{entry.term}</h2>
            <p className="text-sm text-slate-600">{entry.definition}</p>
          </Card>
        ))}
      </div>

      <Link to="/guia" className="text-sm font-medium text-primary-600 hover:underline">
        Volver a Guía
      </Link>
    </section>
  );
}
